import { z } from "zod";

// --- Workspace list ---

export const extensionWorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
});

export const extensionWorkspacesResponseSchema = z.object({
  workspaces: z.array(extensionWorkspaceSchema),
});

export type ExtensionWorkspace = z.infer<typeof extensionWorkspaceSchema>;
export type ExtensionWorkspacesResponse = z.infer<
  typeof extensionWorkspacesResponseSchema
>;

// --- Channel list ---

export const extensionChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.enum(["channel", "dm", "group_dm"]).nullable(),
  is_private: z.boolean(),
  member_names: z.array(z.string()).optional(),
});

export const extensionChannelsQuerySchema = z.object({
  workspace_id: z.string().min(1),
});

export const extensionChannelsResponseSchema = z.object({
  channels: z.array(extensionChannelSchema),
});

export type ExtensionChannel = z.infer<typeof extensionChannelSchema>;
export type ExtensionChannelsResponse = z.infer<
  typeof extensionChannelsResponseSchema
>;

// --- Send message ---

export const extensionSendMessageBodySchema = z.object({
  channel_id: z.string().min(1),
  content: z.string().min(1).max(4000),
});

export const extensionSendMessageResponseSchema = z.object({
  id: z.string(),
  channel_id: z.string(),
  content: z.string(),
  created_at: z.string(),
});

export type ExtensionSendMessageBody = z.infer<
  typeof extensionSendMessageBodySchema
>;
export type ExtensionSendMessageResponse = z.infer<
  typeof extensionSendMessageResponseSchema
>;
